const errorCodes = {
  // Account & Authentication
  ACCOUNT_SUSPENDED: "Your account has been suspended",
  USER_NAME_SHOULD_NOT_BE_BLANK: "Username cannot be empty",
  PASSWORD_SHOULD_NOT_BE_BLANK: "Password cannot be empty",
  INVALID_EMAIL_ID: "Invalid email address",
  INVALID_TOKEN_OR_EXPIRED: "Token is invalid or expired",
  INVALID_USER_ID: "Invalid user ID",
  USER_DOES_NOT_EXIST: "User does not exist",
  USER_ALREADY_EXIST: "User already exists",
  INVALID_USER_NAME: "Invalid username",
  INVALID_PASSWORD: "Invalid password",
  INVALID_EMAIL: "Invalid email",
  SUSPENDED_PLAYER: "Player account is suspended",
  PLAYER_ACCOUNT_CLOSED: "Player account is closed",
  USER_SELF_EXCLUDED: "Your account is self-excluded",

  // OTP & Verification
  OTP_SEND_SUCCESS: "OTP sent successfully",
  OTP_EXPIRED: "OTP has expired",
  INVALID_OTP: "Invalid OTP",
  PHONE_NUMBER_VERIFICATION_SUCCESS: "Phone number verified successfully",
  EMAIL_VERIFICATION_SUCCESS: "Email verified successfully",
  UPDATE_EMAIL_TO_VERIFY_ACCOUNT: "Please update email to verify account",
  UPDATE_PHONE_NUMBER_VERIFY_ACCOUNT: "Please update phone number to verify account",

  // Login & Session
  LOGIN_SUCCESS: "Login successful",
  LOGTOUT_PLAYER_SUCCESS: "Logout successful",
  DAILY_TIMEOUT_LIMIT_EXCEEDED: "Daily timeout limit exceeded",

  // Password & Security
  PASSWORD_VALIDATION_FAILED: "Password validation failed",
  CHANGE_PASSWORD_SUCCESS: "Password changed successfully",
  RESET_PASSWORD_SUCCESS: "Password reset successfully",

  // Promo & Codes
  PROMO_CODE_MAX_ALLOWED_LENGTH_IS_30_CHARACTERS: "Promo code cannot exceed 30 characters",

  // Email
  EMAIL_ALREADY_EXIST: "Email already exists",

  // Phone
  INVALID_PHONE_NUMBER: "Invalid phone number",
  PHONE_NUMBER_ALREADY_EXIST: "Phone number already exists",
  INVALID_COUNTRY_CODE: "Invalid country code",

  // Deposit & Withdrawal
  INSUFFICIENT_FUNDS: "Insufficient funds",
  ADD_DEPOSIT_SUCCESS: "Deposit added successfully",
  DEPOSIT_CONFIRMATION_FAILED: "Deposit confirmation failed",
  WITHDRAW_INITIATION_SUCCESS: "Withdrawal initiated successfully",
  WITHDRAW_AMOUNT_SUCCESS: "Withdrawal successful",
  WITHDRAW_CONFIRMATION_FAILED: "Withdrawal confirmation failed",
  WITHDRAW_CANCEL_SUCCESS: "Withdrawal cancelled successfully",
  MULTIPLE_WITHDRAWALS_NOT_ALLOWED: "Multiple simultaneous withdrawals are not allowed",
  AMOUNT_SHOULD_SHOULD_NOT_EMPTY: "Amount cannot be empty",
  AMOUNT_SHOULD_BE_GREATER_THAN_ZERO: "Amount should be greater than zero",
  AMOUNT_SHOULD_BE_GREATER_THAN_MINIMUM_LIMIT: "Amount should be greater than minimum limit",
  AMOUNT_SHOULD_BE_LESSER_THAN_MAXIMUM_LIMIT: "Amount should be lesser than maximum limit",

  // Bank Details
  ADD_BANK_DETAILS_SUCCESS: "Bank details added successfully",
  GET_BANK_DETAILS_SUCCESS: "Bank details retrieved successfully",
  UPDATE_BANK_DETAILS_SUCCESS: "Bank details updated successfully",
  DELETE_BANK_DETAILS_SUCCESS: "Bank details deleted successfully",
  INVALID_BANK_DETAILS_ID: "Invalid bank details ID",
  BANK_ALREADY_EXIST: "Bank account already exists",
  INVALID_IFSC_CODE: "Invalid IFSC code",
  ADD_BANK_LIMIT_EXCEEDED: "Bank account limit exceeded",

  // Betting
  PLACE_BET_ERROR: "Failed to place bet",
  PLACE_BET_SUCCESS: "Bet placed successfully",
  USER_DAILY_BET_LIMIT_EXCEEDED: "Daily betting limit exceeded",
  USER_WEEKLY_BET_LIMIT_EXCEEDED: "Weekly betting limit exceeded",
  USER_MONTHLY_BET_LIMIT_EXCEEDED: "Monthly betting limit exceeded",

  // User Limits - Success
  USERLIMITS_UPDATE_SUCCESS: "Limit updated successfully",

  // User Limits - Errors
  USERLIMITS_UPDATE_ERROR: "Failed to update limit",
  USERLIMITS_MAX_UPDATES_ERROR: "Maximum updates limit reached",

  // Deposit Limit Updates
  DAILY_DEPOSIT_LIMIT_UPDATES_PER_DAY_EXCEEDED: "You can only update daily deposit limit once per day",
  WEEKLY_DEPOSIT_LIMIT_UPDATES_PER_DAY_EXCEEDED: "You can only update weekly deposit limit once per day",
  MONTHLY_DEPOSIT_LIMIT_UPDATES_PER_DAY_EXCEEDED: "You can only update monthly deposit limit once per day",

  // Stake/Betting Limit Updates
  DAILY_STAKE_LIMIT_UPDATES_PER_DAY_EXCEEDED: "You can only update daily betting limit once per day",
  WEEKLY_STAKE_LIMIT_UPDATES_PER_DAY_EXCEEDED: "You can only update weekly betting limit once per day",
  MONTHLY_STAKE_LIMIT_UPDATES_PER_DAY_EXCEEDED: "You can only update monthly betting limit once per day",

  TIME_LIMIT_UPDATES_PER_DAY_EXCEEDED: "You can only update time limit once per day",

  SELF_EXCLUSION_UPDATES_PER_DAY_EXCEEDED: "You can only update self-exclusion limit once per day",

  USERLIMITS_MONTHLY_DEPOSIT_LIMIT_LESSER_THAN_DAILY_LIMIT: "Monthly limit cannot be less than daily limit",
  USERLIMITS_MONTHLY_DEPOSIT_LIMIT_LESSER_THAN_WEEKLY_LIMIT: "Monthly limit cannot be less than weekly limit",
  USERLIMITS_WEEKLY_DEPOSIT_LIMIT_LESSER_THAN_DAILY_LIMIT: "Weekly limit cannot be less than daily limit",
  MONTHLY_STAKE_LIMIT_LESSER_THAN_DAILY_LIMIT: "Monthly betting limit cannot be less than daily limit",
  MONTHLY_STAKE_LIMIT_LESSER_THAN_WEEKLY_LIMIT: "Monthly betting limit cannot be less than weekly limit",
  WEEKLY_STAKE_LIMIT_LESSER_THAN_DAILY_LIMIT: "Weekly betting limit cannot be less than daily limit",

  // Deposit Limit Exceeded
  USER_DAILY_DEPOSIT_LIMIT_EXCEEDED: "Daily deposit limit exceeded",
  USER_WEEKLY_DEPOSIT_LIMIT_EXCEEDED: "Weekly deposit limit exceeded",
  USER_MONTHLY_DEPOSIT_LIMIT_EXCEEDED: "Monthly deposit limit exceeded",

  // KYC
  KYC_FILE_UPLOAD_SUCCESS: "KYC file uploaded successfully",
  KYC_STATUS_UPDATE_SUCCESS: "KYC status updated successfully",

  // User Account
  USER_NAME_ALREADY_EXIST: "Username already exists",
};

export default errorCodes;
